<div class="bracket-overall">
    <div class="ui-g-12 bracket-title">{{ bracket.bracketName }}</div>

    <div class="bracket-container">
        <div *ngFor="let round of rounds; let i = index" class="bracket-round">
            <bracket-round [bracket]="bracket" [round]="round"></bracket-round>
        </div>
    </div>
</div>
